export default __webpack_public_path__ + "assets/models/dda9dc1add5fd087fce8098137f41613.glb";